import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-GSN9YGCR0B", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}